// import './App.css';
// import Tabs from './Tabs';
// import logo from './logo.png';
// import React, { useState } from 'react';
// import HomePageContent from './HomePageContent';
// import ProductsContent from './ProductsContent';
// import UsedItemsContent from './UsedItemsContent';
// import ContactUsContent from './ContactUsContent';
// import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
// import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

// function App() {

//   const [activeTab, setActiveTab] = useState('Tab1');

//   const handleTabChange = (tabName) => {
//     setActiveTab(tabName);
//   };

//   const renderContent = () => {
//     switch (activeTab) {
//       case 'Tab1':
//          return <HomePageContent />;
//       case 'Tab2':
//         return <ProductsContent />;
//       case 'Tab3':
//         return <UsedItemsContent />;
//       case 'Tab4':
//         return <ContactUsContent />;
//       default:
//         return null;
//     }
//   };

// //main webpage
//   return (
//     <div className="App">
//       <header className="App-header">
//         <h1 onClick={() => handleTabChange('Tab1')} style={{ cursor: 'pointer' }}>
//           {/* Connoisseur Audio  */}
//           <img src={logo} alt="CAlogo" />
//         </h1> 
//         <div className="Tabs-container">
//           <Tabs onTabChange={handleTabChange} />
//         </div>
//       </header>
//       <main className="main-content">
//       <div className="Tabs-content">
//         {renderContent()}
//       </div>
//       </main>
//       <footer className="footer">
//         <div className="social-icons">
//           <a href="https://www.facebook.com/people/Connoisseur-Audio/100063910389216/?fref=ts" target="_blank" rel="noopener noreferrer">
//             <FaFacebook />
//           </a>
//           {/* <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
//             <FaInstagram />
//           </a> */}
//           <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer">
//             <FaWhatsapp />
//           </a>
//         </div>
//         <div className="footer-text">
//           <p>&copy;  2024 Connoisseur Audio. All rights reserved.</p>
//         </div>
//       </footer>
//     </div>
//   );
// }

// export default App;


import './App.css';
import './HomePage.css';
import './Tabs.css';
import './index.css';
import './Products.css';
import './ProductDetail.css';
import './ContactUs.css';
import './UsedItems.css';
import './responsive.css';
import Tabs from './Tabs';
import logo from './logo.png';
import React from 'react';
import HomePageContent from './HomePageContent';
import ProductsContent from './ProductsContent';
import ProductDetail from './ProductDetail';
import UsedItemsContent from './UsedItemsContent';
import UsedItemsDetail from './UsedItemsDetail';
import ContactUsContent from './ContactUsContent';
import { FaFacebook, FaWhatsapp } from 'react-icons/fa';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';


function App() {

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1 style={{ cursor: 'pointer' }}>
            <Link to="/">
              <img src={logo} alt="CAlogo" />
            </Link>
          </h1> 
          <div className="Tabs-container">
            <Tabs />
          </div>
        </header>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePageContent />} />
            <Route path="/products" element={<ProductsContent />} />
            <Route path="/used-items" element={<UsedItemsContent />} />
            <Route path="/contact-us" element={<ContactUsContent />} />
            <Route path="/products/:brandId" element={<ProductDetail />} /> {/* Route for product details */}
            <Route path="/usedItems/:itemName" element={<UsedItemsDetail />} /> {/* Route for used items details details */}
          </Routes>
        </main>

        <footer className="footer">
          <div className="social-icons">
            <a href="https://www.facebook.com/people/Connoisseur-Audio/100063910389216/?fref=ts" target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://wa.me/6583681338?text=Hello%20Connoisseur%20Audio!" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
          </a>    
          </div>
          <div className="footer-text">
            <p>&copy;  2026 Connoisseur Audio. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
